import React, { useState } from 'react';
import { useGlobalContext } from 'GlobalContext';
import { useFetchData } from 'services/api/useFetchData';
import SettingsContainer, { SettingsSettingType } from 'components/settings/SettingsContainer';
import SecondaryButton from 'components/buttons/SecondaryButton';
import '../../../style/scss/tickets.scss';

// The deal settings page with the forwarding address and its pipeline
const DealSettings: React.FC = () => {
    const { setFloatingAlert } = useGlobalContext();
    const [copied, setCopied] = useState(false);

    // Fetch the inbound address of the environment
    const { response } = useFetchData({ apiUrl: 'get_deal_inbound_address' });
    const inboundAddress: string | undefined = response?.inbound_address;

    // Copy the inbound address to the clipboard
    const handleCopy = async () => {
        if (!inboundAddress) return;
        try {
            await navigator.clipboard.writeText(inboundAddress);
            setCopied(true);
            setFloatingAlert({ type: 'success', message: 'deal.settings.address_copied_message' });
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Copying the address failed', error);
        }
    };

    // The settings of the page
    const settings: SettingsSettingType[] = [
        {
            title: 'deal.settings.inbound_address_title',
            explanationText: 'deal.settings.inbound_address_explanation',
            tooltipText: 'deal.settings.inbound_address_steps',
            fields: [
                {
                    type: 'render',
                    render: () => (
                        <div className='inbound-address'>
                            <code>{inboundAddress || '...'}</code>
                            <SecondaryButton
                                label={copied ? 'deal.settings.copied_label' : 'deal.settings.copy_label'}
                                size='small'
                                onClick={handleCopy}
                            />
                        </div>
                    )
                },
                {
                    type: 'dropdown',
                    label: 'deal.settings.pipeline_label',
                    name: 'deal_inbound_pipeline',
                    apiRequest: [{
                        endpoint: 'get_pipeline_list',
                        object: 'pipeline',
                        params: { is_active: true }
                    }],
                    disabled_selected: 'deal.settings.pipeline_placeholder',
                    allowNoneOption: true,
                    showSearch: false,
                    optionFormat: 'name',
                    selectionFormat: 'name',
                    group: 'field-row',
                    width: '40%'
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default DealSettings;
